import focusWithin from 'focus-within';

// Focus within
focusWithin(document, {
  attr: false,
  className: 'focus-within',
});
